export const BREAKPOINTS = {
  smUp: "(min-width : 576px)",
  smDown: "(max-width : 576px)",
  mdUp: "(min-width : 768px)",
  mdDown: "(max-width : 768px)",
  lgUp: "(min-width : 992px)",
  lgDown: "(max-width : 992px)",
  xlUp: "(min-width : 1200px)",
  xlDown: "(max-width : 1200px)",
  xxlUp: "(min-width : 1600px)",
  xxlDown: "(max-width : 1600px)",
};
export default BREAKPOINTS;
